import type { WorkspacePersona } from "@/config/workspacePersona";

export const HELPER_ROLE_CONFIRMATION: Record<WorkspacePersona, string> = {
  district_leader:
    "Got it — you're leading across schools or the district. HeyBodhi will align tools and language with that scope.",
  leader: "Got it — you're leading at the building or program level. We'll tune navigation for school leaders.",
  teacher: "Got it — you're in classroom teaching. We'll streamline the experience for educators.",
  support_staff:
    "Got it — you support students and staff in specialized or paraprofessional roles. HeyBodhi will speak your language.",
  classified_staff:
    "Got it — you keep schools and districts running from the office, support desk, or operations side. HeyBodhi is for you too.",
};

export const ARC_PLACEHOLDER: Record<WorkspacePersona, string> = {
  district_leader: "I stepped into district leadership because…",
  leader: "I became a school leader because…",
  teacher: "I became a teacher because…",
  support_staff: "I do this work because…",
  classified_staff: "I do this work because…",
};

export const FIRST_SESSION_PROMPT = `You don't need to have the right words — I'm designed to help you find them. What feels most true for you right now?`;
